export const bucket = 'socialapp-c26ee.appspot.com';
